export default function identity<T>(value: T) {
    return value;
}
